import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DocumentForm from '../../components/Documents/DocumentForm';

const DocumentEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(`/app/documents/${id}`);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Edit Document</h1>
          <p className="text-gray-600 mt-2">
            Update document information and metadata
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <DocumentForm documentId={id} onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  );
};

export default DocumentEdit;


